import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { MotifButton, MotifIcon, MotifProgressLoader } from "@ey-xd/motif-react";
import { deleteIcon } from '../../common/MotifIcons';
import { getImagePath } from '../../common/utility/utility'; // Assuming this utility function is defined in utils

import "./partnerFileUpload.scss";

export function FileViewerTest({
  open,
  onClose,
  isLoading,
  fileUrl,
  fileName,
  setOpenDialog,
  setFileViewerOpen,
  deleteTempFiles,
  baseURL
}) {
  // Determine file type from URL (or fallback to file name)
  const getFileType = (url, name) => {
    const urlExtension = url?.split('.').pop()?.split('?')[0]?.toLowerCase();
    const nameExtension = name?.split('.').pop()?.toLowerCase();
    return urlExtension || nameExtension;
  };

  const handleFileDelete = () => {
    setOpenDialog(true);
  };

  const handleFileClose = () => {
    setFileViewerOpen(false);
    deleteTempFiles();
  };

  const fileType = getFileType(fileUrl, fileName);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="800px">
      <DialogTitle>
        <div className="dialog-header">
          <div className="dialog-file-icon-wrapper">
            <img src={getImagePath(fileName)} alt="file icon" className="dialog-file-icon" />
          </div>
          <div className="dialog-file-name">{fileName}</div>
        </div>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleFileClose}
          aria-label="close"
          style={{ position: 'absolute', right: 30, top: 16 }}        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {isLoading ? (
        <>
          <MotifProgressLoader show variant="default" />
          <DialogContent>
            <div className="dialog-content-container"></div>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogContent>
            <div style={{ width: '700px', height: '300px' }}>
              {fileUrl ? (
                <>
                  {/* PDF viewer */}
                  {['doc', 'docx', 'ppt', 'pptx','pdf'].includes(fileType) && (
                    <iframe
                        src={fileUrl}
                        title="Document Viewer"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />
                  )}

                  {/* Office documents via Office online viewer */}
                  {['xls', 'xlsx', 'xlsm', 'xlsb'].includes(fileType) && (
                    <iframe                                            
                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(`${baseURL}/api/partners/viewfile?sasUrl=${encodeURIComponent(fileUrl)}`)}`}
                      title="Office Document Viewer"
                      width="100%"
                      height="100%"
                      style={{ border: 'none' }}
                    />
                  )}
                </>
              ) : (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  fontSize: '16px',
                  color: '#888'
                }}>
                  File not found or unavailable. Please check file URL.
                </div>
              )}
            </div>
          </DialogContent>

          <DialogActions>
            <MotifButton variant="danger" className="dialog-delete-button" onClick={handleFileDelete}>
              <MotifIcon src={deleteIcon} /> Delete
            </MotifButton>
            <MotifButton onClick={handleFileClose} variant="primary">
              Close
            </MotifButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}

export default FileViewerTest;
